// extracted by mini-css-extract-plugin
export var axisLabel = "LineGraph-module--axisLabel--794b7";
export var container = "LineGraph-module--container--40d03";
export var legend = "LineGraph-module--legend--0fb00";
export var legendIcon = "LineGraph-module--legendIcon--45e56";
export var legendItem = "LineGraph-module--legendItem--84787";
export var path = "LineGraph-module--path--25046";